function setDonateLoaded() {
  document.getElementsByTagName('body')[0].setAttribute('donate-loaded', true);
}

setDonateLoaded();
